<div class="jumbotron container-fluid">
    <div class="row">
        <div class="col">
            <h1 class="display-4" [innerHTML]="'pub.singleComponet.welcome' | translate"></h1>
            <h2 translate>pub.singleComponet.title</h2>
        </div>
        <div class="col portada d-none d-md-block"><img src="assets/images/imagenJumbotron2.png"></div>
        <div class="auxiliar col-12 ">
            <div class="col"></div>
            <div class="flecha"></div>
            <div class="col"></div>
        </div>
    </div>
</div>

<app-pub-menu></app-pub-menu>

<div class="container-fluid empresasdeFacturacionUnico">
    <!--Empresa-->
    <section *ngIf="invoicingServiceSlug && load">
        <div class="row tarjetaEmpresa">
            <div class="col">
                <!-- Empresa -->
                <div class="card infoEmpresa">
                    <div class="card-header">
                        <div class="row">
                            <div class="col text-left">
                            </div>
                            <div class="col serviciosPrestados">
                                <div class="row">
                                    <div class="col-6 col-sm" *ngFor="let application of invoicingServiceSlug.applications">
                                        <i title="{{ getApplicationTitle(application.name) | translate }}"
                                           class="icono fa {{ getApplicationClass(application.name) }} fa-2x">
                                        </i>
                                        <span class="leyenda ng-binding" translate>{{ getApplicationTitle(application.name) }}</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-3 text-center">
                                <img _ngcontent-c4="" src="{{ invoicingServiceSlug.logo }}">
                            </div>
                            <div class="col-9 textoProveedor">
                                <p [innerHTML]="'pub.listComponent.introduccionSello' |
								translate:{ nombreEmpresa: invoicingServiceSlug.invoicingService.tradeName }"></p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Empresa end -->
            </div>
        </div>
    </section>

    <section *ngIf="!invoicingServiceSlug && load">
        <div class="row tarjetaEmpresa bloqueNotFound">
            <div class="col">

                    <div class="text-center" [innerHTML]="'pub.listComponent.introduccionSelloNotFound' | translate">

                    </div>
            </div>
        </div>
    </section>
    <!--Empresa-->

    <h5 class="text-center">
        <span class="separadorUp"></span>
        <p [innerHTML]="'pub.listComponent.introduction2' | translate"></p>
    </h5>
</div>



// WEBPACK FOOTER //
// ./src/app/app-public/pub-invoicing-services-detail/pub-invoicing-services-detail.component.html